var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.5 50.37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.39 50.37-8.39-8.47v-33.83l8.43-8.07h21.86l8.21 8.1v33.77l-8.17 8.5zm15.9-13.11v-24.15h-10.08v24.15z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9 48.85-7.48-7.59v-32.52l7.54-7.22h20.58l7.36 7.23v32.5l-7.32 7.6zm16.1-10.07.67-.74v-26l-.54-.49h-11.86l-.67.56v25.89l.79.81z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29 3h-19.31l-6.69 6.4v31.21l6.65 6.72h19.35l6.47-6.72v-31.21zm-1.68 35.68-1.53 1.62h-12.94l-1.67-1.68v-27.14l1.57-1.41h13.15l1.42 1.35z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.ec631da48b6e30a671c565e4972a37d3.svg";
export { ForwardRef as ReactComponent };